import { getChoicesByBinaryMask } from "../../questions/utils"
import { MultiAnswerChoices } from "./MultiAnswerSingle"
import type { IMultiAnswerProps } from "./types"

export function MultiAnswerMultiple(props: IMultiAnswerProps) {
  return (
    <MultiAnswerChoices
      getSelected={(value) => getChoicesByBinaryMask(value)}
      choices={props.question.meta.choices.map((choice: string, idx: number) => ({
        value: idx,
        label: choice,
      }))}
      {...props}
    />
  )
}
